import moment from 'moment';
import { ScrollUtil } from 'utilities/scroll';
import { Scopes } from 'apps/scopes';

export class Global extends Scopes {
  public static cellWidth: number = 20;
  public static cellHeight: number = 20;
  public static totalDays: number = 90;

  public static getCellWidth(){      return this.cellWidth; }
  public static getTotalDays(){      return this.totalDays; }
}

export class ScrollModel extends ScrollUtil {
}

export class LineCell {
  public static todayStr;
  public year:  string;
  public month: string;
  public day:   string;
  public index: number;
  public week:  number;
  public today: boolean;
  constructor(mom, index){
    this.index = index;
    this.year  = mom.format('YYYY');
    this.month = mom.format('MM');
    this.day   = mom.format('DD');
    this.week  = mom.day();
    if(LineCell.todayStr == null){ LineCell.todayStr = moment().format('YYYYMMDD');}
    if(mom.format('YYYYMMDD') == LineCell.todayStr){ this.today = true; }
  }
  toString():string{
    return this.year + '-' + this.month + '-' + this.day;
  }
}

export class LineCalendarCell extends LineCell{
  public isShowMonth: boolean;
  constructor(moment, index){
    super(moment, index);
    this.setIsShowMonth();
  }
  private setIsShowMonth(){
    if(this.isShowMonth !== undefined){ return this.isShowMonth; }
    this.isShowMonth = this.shouldShowMonth();
    return this.isShowMonth;
  }
  private shouldShowMonth(){
    if(this.index == 0){ return true; }
    // if(this.index <= 10) { return false; }
    if(this.day == '01' || this.day == '11' || this.day == '21'){ return true; }
    return false;
  }
}

export class LineMenu {
  public lineId: number;
  public element: HTMLElement;
  constructor(lineId: number, element: HTMLElement){
    this.lineId = lineId;
    this.element = element;
  }
  lineData(){
    return Global.getLineData(this.lineId);
  }
  orderData(){
    return Global.getOrderData(this.lineData().order_id);
  }
}

export class LineSelectedCell {
  public lineId: number;
  public cell: LineCalendarCell;
  public element: HTMLElement;
  constructor(lineId: number, cell: LineCalendarCell, element: HTMLElement){
    this.lineId = lineId;
    this.cell = cell;
    this.element = element;
  }
  toString(): string {
    return this.cell.toString();
  }
}
export class LineMemoSuper {
  public lineId: number;
  public scheduleId: number;
  public index: number;
  taskId(){
    return this.taskData().id;
  }
  taskData(){
    return Global.getTaskDataByScheduleId(this.scheduleId);
  }
  taskScheduleIds(){
    return this.taskData().schedules;
  }
  scheduledIndex(){
    // 同lineで同taskのスケジュールは日付をまたぐことがあり複数
    // そのためスプリットしたスケジュールの内、
    // 後ろのスケジュールは何日目のメモかは前のスケジュールから日数を数える必要がある。
    let index = 0;
    let taskScheduleIds = this.taskScheduleIds();
    for(let i=0;i<taskScheduleIds.length;i++){
      let scheduleId = taskScheduleIds[i]
      if(scheduleId == this.scheduleId){
        return index + this.index;
      } else {
        let schedule = Global.getScheduleData(scheduleId);
        let pos: CellPositionSuper = this.newCellPosition(schedule)
        index += pos.number();
      }
    }
    console.error('something wrong');
  }
  composite_id(){
    return this.taskId() + "_" + this.scheduledIndex();
  }
  value(){
    let data = Global.getTasksMemoData(this.composite_id());
    if(data){ return data.value; }
    return '';
  }
  newCellPosition(schedule){
    return new CellPosition(schedule.start_time, schedule.end_time)
  }
}
export class LineMemo  extends LineMemoSuper {
  constructor(lineId: number, scheduleId: number, index: number){
    super();
    this.lineId     = lineId;
    this.scheduleId = scheduleId;
    this.index      = index;
  }
}
export class LineMemoLocal  extends LineMemoSuper {
  baseDate: string;
  constructor(lineId: number, scheduleId: number, index: number, baseDate: string){
    super();
    this.lineId     = lineId;
    this.scheduleId = scheduleId;
    this.index      = index;
    this.baseDate   = baseDate;
  }
  newCellPosition(schedule){
    return new CellPositionLocal(this.baseDate, schedule.start_time, schedule.end_time)
  }
}

export class LineSelectedMemo extends LineMemo{
  public element: HTMLElement;
  constructor(lineId: number, scheduleId: number, index: number, element: HTMLElement){
    super(lineId, scheduleId, index);
    this.element    = element;
  }
}

export class LineSelectedTask {
  public taskId: number;
  public lineId: number;
  constructor(taskId: number, lineId: number){
    this.taskId = taskId;
    this.lineId = lineId;
  }
  phaseData(){
    return Global.getPhaseData(this.taskData().phase_id);
  }
  taskData(){
    return Global.getTaskData(this.taskId);
  }
  lineData(){
    return Global.getLineData(this.lineId);
  }
  orderData(){
    return Global.getOrderData(this.lineData().order_id);
  }
  orderId(){
    return this.orderData().id;
  }
}

export class LineOverSchedule {
  public scheduleId: number;
  public index: number;
  public element: HTMLElement;
  constructor(scheduleId: number, index: number, element: HTMLElement){
    this.scheduleId = scheduleId;
    this.index = index;
    this.element = element;
  }
  task():LineSelectedTask {
    let s = Global.getScheduleData(this.scheduleId);
    return new LineSelectedTask(s.task_id, s.line_id);
  }
  taskData(){
    let s = Global.getScheduleData(this.scheduleId);
    return Global.getTaskData(s.task_id);
  }
  memo():LineMemo {
    let s = Global.getScheduleData(this.scheduleId);
    return new LineMemo(s.line_id, this.scheduleId, this.index);
  }
  isSame(overSchedule:LineOverSchedule):boolean{
    if(this.scheduleId != overSchedule.scheduleId){ return false; }
    if(this.index != overSchedule.index) { return false; }
    return true;
  }
  memoValue(){
    return this.memo().value();
  }
  phaseData(){
    return Global.getPhaseData(this.taskData().phase_id)
  }
}

export class LineOverOrdersPhase {
  public element: HTMLElement;
  public id: number;
  public code: number;
  public colorcode: string;
  public unit_price: {label: string, value: string} | null;
  public material: {label: string, value: string} | null;
  public heat_treatment: {label: string, value: string} | null;
  public description: {label: string, value: string} | null;
  // phase_data > data.orders_planner_order_{n}.phases[] like below..
  // {id: 3, code: 4, colorcode: "#e32c59", unit_price: {value: '', label: ''}, description: {value: '', label: ''}}
  constructor(phase_data: any, element: HTMLElement){
    this.element      = element;
    this.id           = phase_data.id;
    this.code         = phase_data.code;
    this.colorcode    = phase_data.colorcode;
    if(!phase_data.unit_price){
      this.unit_price = null;
    }else{
      this.unit_price   = phase_data.unit_price;
    }
    if(!phase_data.material){
      this.material = null;
    }else{
      this.material   = phase_data.material;
    }
    if(!phase_data.heat_treatment){
      this.heat_treatment = null;
    }else{
      this.heat_treatment   = phase_data.heat_treatment;
    }
    this.description  = phase_data.description;
  }
}

export class LineSelectedSchedule {
  public scheduleId: number;
  public lineId: number;
  constructor(scheduleId: number, lineId: number){
    this.scheduleId = scheduleId;
    this.lineId = lineId;
  }
  task():LineSelectedTask{
    let scheduleData = Global.getScheduleData(this.scheduleId);
    return new LineSelectedTask(scheduleData.task_id, this.lineId)
  }
  taskData(){
    return Global.getTaskDataByScheduleId(this.scheduleId);
  }
}

export class CellPositionSuper {
  public isStartOverLeft:  boolean = false;
  public isStartOverRight: boolean = false;
  public isEndOverLeft:    boolean = false;
  public isEndOverRight:   boolean = false;
  public left:  number = 0;
  public right: number = 0;
  public leftDays:  number = 0;
  public rightDays: number = 0;
  baseStart(){
    return Global.getPlannerData().start
  }
  initLeft(start_time, startPlus){
    this.leftDays = Math.floor(this.getDays(this.baseStart(), start_time) + startPlus);
    this.initProps(
      this.leftDays,
      (n) => { this.left = n; },
      (b) => { this.isStartOverLeft = b; },
      (b) => { this.isStartOverRight = b; }
    );
  }
  initRight(end_time, endPlus){
    this.rightDays = Math.floor(this.getDays(this.baseStart(), end_time) + 1 + endPlus);
    this.initProps(
      this.rightDays,
      (n) => { this.right = n; },
      (b) => { this.isEndOverLeft = b; },
      (b) => { this.isEndOverRight = b; }
    );
  }
  initProps(days, setter, setIsOverLeft, setIsOverRight){
    let totalDays = Global.getTotalDays();
    if(days < 0){
      setIsOverLeft(true);
      setter(0);
    } else if(days > totalDays) {
      setIsOverRight(true);
      setter(totalDays * Global.getCellWidth());
    } else {
      setter(Math.floor(days) * Global.getCellWidth());
    }
  }
  getDays(from, to){
    let fromMoment = moment(from, Global.timeFormat);
    let toMoment   = moment(to, Global.timeFormat);
    var duration = moment.duration(toMoment.diff(fromMoment));
    return duration.asDays();
  }
  number(){
    return this.rightDays - this.leftDays;
  }
  width(){
    return this.right - this.left;
  }
  setStyleFor(element){
    element.style.left  = this.left    + 'px';
    element.style.width = this.width() + 'px';
  }

}

export class CellPosition extends CellPositionSuper {
  constructor(start_time, end_time, startPlus = 0, endPlus = 0){
    super();
    this.initLeft(start_time, startPlus);
    this.initRight(end_time, endPlus);
  }
}
export class CellPositionLocal extends CellPositionSuper {
  baseDate: string;
  constructor(baseDate, start_time, end_time){
    super();
    this.baseDate = baseDate;
    this.initLeft(start_time, 0);
    this.initRight(end_time, 0);
  }
  baseStart(){
    return this.baseDate;
  }
}
export class DeadlinePosition extends CellPositionSuper {
  constructor(deadline){
    super();
    this.initRight(deadline, 0);
  }
  setStyleFor(element){
    element.style.left  = this.right    + 'px';
  }
}
